import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from "react-toastify"
import CenteredModal from '../../../../CenteredModal'
import FormValidators from '../../../../../../helpers/FormValidators'
import FormValidationMessages from '../../../../../../constants/FormValidationMessages'
import TextField from '../../../../FormFields/TextField'
import { generateClientCertificate } from '../../../../../../redux/actions/application'
import './style.sass'

const GenerateCertificate = ({ releaseId, clientId }) => {

  // ==== Redux state ====
  const dispatch = useDispatch()
  const isGeneratingClientCertificate = useSelector(({ application }) => application.isGeneratingClientCertificate)

  // ==== Local state ====  
  const [password, setPassword] = useState("")
  const [errorMessage, setErrorMessage] = useState(null)
  const [requestCertModalIsVisible, setRequestCertModalIsVisible] = useState(false)

  const onRequestClientCertificate = async () => {
    const isValid = validateForm(password)
    if (!isValid) {
      toast.error('Please enter a valid password')
      return
    }
    const res = await dispatch(generateClientCertificate(releaseId, clientId, password))

    if (res) {
      toast.success('Successfully generated certificate')
      setRequestCertModalIsVisible(false)
      setPassword("")
      return
    }
    toast.error('Something went wrong!')
  }

  const onCancel = () => {
    setPassword("")
    setErrorMessage(null)
    setRequestCertModalIsVisible(false)
  }

  const onChangeHandler = (value) => {
    setPassword(value)
    validateForm(value)
  }

  const validateForm = (value) => {
    if (FormValidators.isNullOrEmpty(value)) {
      setErrorMessage(FormValidationMessages.REQUIRED)
      return false
    }
    setErrorMessage(null)
    return true
  }

  return (
    <div className="generate-certificate-component-container">
      <p className="generate-certificate-field-label">For authentication you need to use a certificate</p>
      <p className="generate-certificate-btn" onClick={() => { setRequestCertModalIsVisible(true) }} >
        <i className="fa fa-download"></i> 
        Generate a new certificate
      </p>
      <CenteredModal
        show={requestCertModalIsVisible}
        title="Generate Certificate"
        successBtnText="Generate"
        onSuccess={onRequestClientCertificate}
        cancelBtnText="Cancel"
        onHide={onCancel}
        btnDisabled={isGeneratingClientCertificate}
      >
        <div>
          <TextField
            displayName="Enter a password to generate certificate"
            placeholder="Password"
            description={"This password should be used for the generated certificate"}
            value={password}
            onChange={onChangeHandler}
            errorMessage={errorMessage}
            disabled={isGeneratingClientCertificate}
          />
        </div>
      </CenteredModal>
    </div>
  )
}

export default GenerateCertificate
